
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { BookingItemProps } from ".";
import { loading, index } from "store/booking";

interface ApiBookingInputProps {
    page: number;
    pageSize: number;
    q?: string;
    specialtyIds?: number[];
    userIds?: number[];
}

type ApiBookingOutputProps = OutputBaseProps<{ list: BookingItemProps[]; pagination?: PaginationProps; }>;

export const apiBookingIndex = async (data: ApiBookingInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiBookingOutputProps>("/api/bookings", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};